export const useMock = () => process.env.NODE_ENV === "development";
